export default "__VITE_ASSET__b581ccfd__"